





















































import gql from 'graphql-tag'
import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppTwoColsCard from '@/components/AppTwoColsCard.vue'
import { CURRENT_USER } from '@/gql/auth'
import { SHOW_LOGIN_MODAL } from '@/gql/misc'
import { Common } from '@/mixins'

@Component({
  components: {
    AppTwoColsCard
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    }
  }
})
export default class extends Mixins(Common) {
  @Prop() readonly userCouponExpiredAt!: number
  @Prop() readonly isUserCoupon!: boolean
  @Prop(Boolean) readonly downloadable!: boolean
  @Prop() readonly coupon!: {
    id: string;
    expiredAt?: number;
    availableDaysAfterDownload?: number;
    type: string;
    param1: number;
    param2: number;
    applicableShoppingMallNames: string;
  }

  currentUser = null
  downloaded = false

  mounted () {
    if (!this.downloadable) {
      this.downloaded = true
    }
  }

  get avaiableDate () {
    if (this.coupon.expiredAt) {
      return `${this.toDateText(this.coupon.expiredAt)} 까지`
    } else if (this.coupon.availableDaysAfterDownload && this.coupon.availableDaysAfterDownload > 0) {
      return `발급 받은 후 ${this.coupon.availableDaysAfterDownload}일 까지`
    } else {
      return '제한 없음'
    }
  }

  get condition () {
    const conditions = []
    if (this.coupon.type === 'WITH_MINIMUM') {
      conditions.push(`${this.formatNumber(this.coupon.param2)}원 이상 구매시 사용 가능`)
    }
    if (this.coupon.type.includes('PERCENTAGE')) {
      conditions.push(`${this.coupon.applicableShoppingMallNames} 일부 상품 한정`)
    } else {
      conditions.push('장바구니 한 번에 대해 사용 가능')
      conditions.push(`최대 ${this.formatNumber(this.coupon.param1)}원 할인 가능`)
    }

    return conditions.join('<br>')
  }

  async onClickCoupon () {
    if (this.downloaded) return

    if (!this.currentUser) {
      await this.$apollo.mutate({ mutation: SHOW_LOGIN_MODAL })
      return
    }

    await this.$apollo.mutate({
      mutation: gql`mutation downloadCoupon($couponId: ID!) {
        downloadCoupon(couponId: $couponId) {
          id
        }
      }`,
      variables: {
        couponId: this.coupon.id
      }
    })
    this.downloaded = true
    await this.showToast('🎉 쿠폰이 발급되었습니다!')
  }
}
